import { StarsDatePicker, Translation } from '@ps/web-shared-components';
import { equalOrBeforeDate, required } from '@ps/web-shared-validators';
import classNames from 'clsx';
import { format } from 'date-fns';
import React from 'react';
import { useField, useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import useDisableField from '../../../../../../hooks/useDisableField';
import { generateExpiryDate } from '../../../../utils/rmf';
import { docTypeField } from '../DocumentTypeField/DocumentTypeField';
import { expiryDateField } from '../ExpiryDateField/ExpiryDateField';

import {
  TXTCLI_Invalid_date,
  TXTWCL_Issue_date,
  TXTWCL_The_date_your_document_was_iss_ELL
} from './IssueDateField.messages.json';
import { container, disable, issueSelect, label, wrapper } from './IssueDateField.scss';

const issueDateField = 'docIssueDate';
const dateFormat = 'yyyy-LL-dd';

const IssueDateField: React.FC = () => {
  const dob = useSelector(select.account.getDateOfBirth);
  const disableField = useDisableField();
  const form = useForm();

  const {
    input: { value: documentType }
  } = useField(docTypeField, { subscription: { value: true } });

  const handleDatePickerClose = ([value]: Date[]) => {
    if (!value) return;
    const expiryDate = generateExpiryDate(value, documentType, dob);
    form.change(expiryDateField, format(expiryDate, dateFormat));
  };

  return (
    <div className={wrapper}>
      <StarsDatePicker
        id={issueDateField}
        label={<Translation {...TXTWCL_Issue_date} />}
        validators={[
          required(TXTWCL_The_date_your_document_was_iss_ELL),
          equalOrBeforeDate(format(new Date(), dateFormat), TXTCLI_Invalid_date)
        ]}
        hideDateFormat
        onClose={handleDatePickerClose}
        className={classNames(issueSelect, {
          [disable]: disableField(issueDateField)
        })}
        customContainerClassName={container}
        labelClassName={label}
      />
    </div>
  );
};

export default IssueDateField;
